import styled from 'styled-components';

export const BeneficiariesListContainer = styled.div`
  margin-top: 3%;
`;

export const BeneficiariesListFooter = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 3%;
`;

export const BeneficiariesListRightBottom = styled.div`
  display: flex;
  justify-content: flex-end;
`;

export const BeneficiariesFormBottom = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const SelectedBeneficiariesContainer = styled.div`
  display: flex;
  flex: 1;
  flex-wrap: wrap;
  width: 100%;
  gap: 10px;
  justify-content: center;
  margin: 10px 0 10px 0;
  overflow-y: scroll;
  &::-webkit-scrollbar {
    width: 10px;
  }

  /* Track */
  &::-webkit-scrollbar-track {
    background: #f3f4f8 0% 0% no-repeat padding-box;
    border-radius: 4px;
    opacity: 1;
  }

  /* Handle */
  &::-webkit-scrollbar-thumb {
    background: #222247 0% 0% no-repeat padding-box;
    border-radius: 4px;
    opacity: 1;
  }

  /* Handle on hover */
  &::-webkit-scrollbar-thumb:hover {
    background: #555;
  }
`;

export const FormInputWrapper = styled.div`
  flex: 0 0 calc(50% - 20px);
`;

export const StyledErrorWrap = styled.p`
  size: 12px;
  padding: 0 16px;
  color: red;
`;
